import React from 'react';
import { useExperimentFlag } from '../../contexts/ExperimentsContext';
import { PromptCard as PromptCardBase } from './PromptCard';
import { PromptCard as PromptCard2 } from './experiments/PromptCard2';
import { PromptCardProps } from './PromptCard.types';

/**
 * Компонент-обертка для выбора между различными версиями PromptCard
 * В зависимости от условий возвращает либо базовую версию, либо экспериментальную
 */
export const PromptCard: React.FC<PromptCardProps> = props => {
    const cardFlag = useExperimentFlag('promptCardRedesign');

    const shouldUseExperimentalVersion = cardFlag === 'new';

    if (shouldUseExperimentalVersion) {
        return React.createElement(PromptCard2, props);
    }

    return React.createElement(PromptCardBase, props);
};
